/**
 * Function: setToggle() - toggles the mobile's hamburger icon so that
 * a hamburger is shown when the offcanvas body is collapsed and a close (X)
 * icon, when it's expanded.
 * Usage: it is intended to be used only when a hamburger toggler is present
 * (mobile)
 */

const setToggle = (toggle) => {
  toggle.onclick = () => {
    toggle.classList.toggle('active');
  }
}

document.addEventListener('DOMContentLoaded', (e) => {
  if (document.querySelector(".navbar-toggler")) setToggle(document.querySelector(".navbar-toggler"));
});